// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"ec0165da","6850":"05be5fc5"}[chunkId] + ".chunk.css";
};